import React, { useState, useEffect, useContext } from 'react'
// Components
import { Col } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Item } from 'components/utils/Dropdown'
import FormItem from 'components/utils/FormItem'
import DropdownFilter from 'components/utils/Filter/DropdownFilter'
import UIFullTextGlobalFilter from 'components/utils/Filter/FullTextGlobalFilter'
// Styles
import { ItemWrapper, FormRowAlignBottom } from 'styles/common'
// Addtitional
import { Loadable } from 'types/loadable'
import { AppContext } from 'App'
import { Tab } from 'static/tabs'
import { Data } from 'helpers/data'
import { TeamRecord } from 'data/TeamRecord'
import { OnTableDataChangeListener } from 'components/utils/Table/_Table'

const SPORT_DEFAULT_ITEM: Item = { id: -1, text: 'Select Sport ...' }
const POPULAR_SHOW_DEFAULT_ITEM: Item = { id: -1, text: 'Show all' }

interface Props {
  readonly selectedId?: number | string
}

const Filters: React.FC<Props> = (p) => {
  const { db } = useContext(AppContext)

  const [sports, setSports] = useState<
    { value: Item; data?: Array<Item> } & Loadable
  >({
    value: SPORT_DEFAULT_ITEM,
    loaded: false,
  })

  const [table, setTable] = useState<Loadable>({
    loaded: false,
  })

  const [popularShowItems, setPopularShowItems] = useState<{
    value: Item
    data?: Array<Item>
  }>({
    value: POPULAR_SHOW_DEFAULT_ITEM,
  })

  useEffect(() => {
    OnTableDataChangeListener.addAndRemove(
      () => !table.loaded && setTable({ loaded: true })
    )

    _setSports()
    _setShowItems()
  }, [])

  const _setSports = async () => {
    const _sports = await Data.getAllSports(db!)

    if (!_sports) return

    const _items = _sports?.map(
      (s) => ({ id: s.id ?? '', text: s.short_name } as Item)
    )

    setSports((prev) => {
      const value = p.selectedId
        ? _items.find((x) => x.id == p.selectedId)
        : null

      return {
        loaded: true,
        value: value ?? prev.value,
        data: _items,
      }
    })
  }

  const _setShowItems = async () => {
    const popularConstantShowItems: Item[] = [
      { id: 'true', text: 'Show Popular' },
      { id: 'false', text: 'Show Unpopular' },
    ]

    setPopularShowItems((prev) => ({
      value: prev.value,
      data: popularConstantShowItems,
    }))
  }

  const handleSportChange = (item: Item) => {
    setSports((prev) => ({ ...prev, value: item, data: prev.data ?? [] }))
  }

  const handlePopularItems = (item: Item) => {
    setPopularShowItems((prev) => ({
      ...prev,
      value: item,
      data: prev.data ?? [],
    }))
  }

  return (
    <FormRowAlignBottom>
      <Col as={ItemWrapper} lg={3}>
        <FormItem
          label={<Form.Label>Sport</Form.Label>}
          input={
            <DropdownFilter
              from={Tab.Teams}
              accessor={'sport_id' as keyof TeamRecord}
              items={sports.data ?? []}
              onSelect={handleSportChange}
              value={sports.value}
              defaultItem={SPORT_DEFAULT_ITEM}
              loading={!sports.loaded || !table.loaded}
              disabled={Boolean(p.selectedId)}
            />
          }
        />
      </Col>
      <Col as={ItemWrapper} lg={3}>
        <FormItem
          label={<Form.Label>Popular</Form.Label>}
          input={
            <DropdownFilter
              from={Tab.Teams}
              accessor={'is_popular' as keyof TeamRecord}
              items={popularShowItems.data ?? []}
              onSelect={handlePopularItems}
              value={popularShowItems.value}
              defaultItem={POPULAR_SHOW_DEFAULT_ITEM}
              loading={false}
            />
          }
        />
      </Col>
      <Col as={ItemWrapper} lg={6}>
        <UIFullTextGlobalFilter
          from={Tab.Teams}
          style={{ disabled: !table.loaded }}
        />
      </Col>
    </FormRowAlignBottom>
  )
}

export default Filters
